import type { AccountType } from "@octopusdeploy/octopus-server-client";
import React from "react";
import { AddOrEditAccountPage } from "./AddOrEditAccountPage";
export interface AddAccountPageProps {
    accountType: AccountType;
}
export function AddAccountPage({ accountType }: AddAccountPageProps) {
    return <AddOrEditAccountPage createNew={true} accountType={accountType}/>;
}
